export function stackSelection<T extends { id: string; z: number }>(
  objects: T[],
  selectedIds: string[],
  direction: 'front' | 'back',
): T[] {
  const selected = new Set(selectedIds);
  const moving = objects.filter((object) => selected.has(object.id)).sort((left, right) => left.z - right.z);
  const rest = objects.filter((object) => !selected.has(object.id));
  if (!moving.length) return objects;
  if (direction === 'front') {
    const top = rest.length ? Math.max(...rest.map((object) => object.z)) : Math.max(...moving.map((object) => object.z));
    const nextZ = new Map(moving.map((object, index) => [object.id, top + 1 + index]));
    return objects.map((object) => (nextZ.has(object.id) ? { ...object, z: nextZ.get(object.id) as number } : object));
  }
  const bottom = rest.length ? Math.min(...rest.map((object) => object.z)) : 0;
  const nextZ = new Map(moving.map((object, index) => [object.id, bottom - moving.length + index]));
  return objects.map((object) => (nextZ.has(object.id) ? { ...object, z: nextZ.get(object.id) as number } : object));
}
